<template>
  <div class="menu-bar">
    <div class="menu-bar-left">
      <!-- <span v-if="uiReply" :class="replyClass" @click.stop="addReply"> 回复 </span> -->

      <div v-if="isFromMsgCenter" class="menu-bar-sub">
        <div class="menu-bar-sub-content">
          <div class="time">
            {{ translateTimeStamp(itemData.postAt) }}
          </div>
          <div v-if="itemData.location" class="place">
            &nbsp;·&nbsp;{{ itemData.location }}
          </div>
          <!-- <div v-if="isCommentSecondDetail" class="menu-bar-title" @click.stop="jumpToArticle">
              <div class="tip">原文:&nbsp;&nbsp;</div>
              <div class="title">{{ title }}</div>
            </div> -->
        </div>

        <div>
          <div
            v-if="uiDelete && userMeta.uid === itemData.owner.id"
            class="btn-button btn-delete"
            @click.stop="onDelete"
          >
            删除
          </div>
        </div>
      </div>

      <div v-else>
        <span class="time">{{ translateTimeStamp(itemData.postAt) }}</span>

        <span v-if="itemData.location" class="place">&nbsp;·&nbsp;{{ itemData.location }}</span>

        <span
          v-if="uiDelete && userMeta.uid === itemData.owner.id"
          class="btn-button btn-delete"
          @click.stop="onDelete"
        >
          删除
        </span>
      </div>
    </div>

    <!-- <div class="menu-bar-right">
      <component
        :is="feedbackIconName"
        v-if="userMeta.uid != itemData.owner.id"
        class="feedback-svg"
        @click.stop="onReport"
      />
    </div> -->
  </div>
</template>

<script lang="ts">
import { computed, toRefs, defineComponent } from 'vue';
import { constant, utils, eventBus } from '@cpc/comment-sdk-common';
import { useGlobalState } from '@cpc/comment-sdk-core-comment';
import { showToast } from '@cpc/comment-sdk-jsapi';

import { useOnCommentClickInject } from '../core/useOnCommentClickProvide/index';
import { commonCommentStat } from '../core/useStat';
import { useBrowserVersion } from '../core/useBrowserVersion';
import { useMsgCenterSub } from '../core/useMsgCenterSub';

// 不适用css引入svg，改用 component是为了解决无图模式需要显示图片问题
// import Feedback from './FeedbackIcon/Feedback.vue';
// import FeedbackDark from './FeedbackIcon/FeedbackDark.vue';

export default defineComponent({
  name: 'MenuBar',

  components: {
    //   Feedback,
    //   FeedbackDark,
  },

  props: {
    itemData: {
      type: Object,
      default() {
        return {};
      },
    },
    type: {
      type: String,
      default: 'new',
    },

    uiDelete: {
      type: Boolean,
      default: true,
    },

    uiReply: {
      type: Boolean,
      default: true,
    },

    isShowTitle: {
      type: Boolean,
      default: false,
    },
  },

  setup(props, { emit }) {
    const { translateTimeStamp } = utils;

    const { userMeta, isNightMode, commentStatus, documentMeta, pageType } = toRefs(
      useGlobalState(),
    );

    const { CommentStatus } = constant;

    const { onCommentClickThrottle } = useOnCommentClickInject();

    const { isBrowserVersionHigherThan } = useBrowserVersion();

    const { isFromMsgCenter } = useMsgCenterSub();

    // const feedbackIconName = computed(() => {
    //   return isNightMode.value ? 'FeedbackDark' : 'Feedback';
    // });

    // const rightAreaIconName = computed(() => {
    //   return isNightMode.value ? 'rightAreaDark' : 'rightArea';
    // });

    const { itemData, isShowTitle } = toRefs(props);

    const onDelete = () => {
      commonCommentStat(20084698);
      const params = {
        commentId: itemData.value.commentId || itemData.value.id,
        replyId: itemData.value.commentId ? itemData.value.id : null,
        content: itemData.value.content,
      };

      window.__commentSdkDelComment(params);

      if (params.replyId) {
        eventBus.emit('ANIMATION_CONTROL', false);
      }
    };

    // const jumpToArticle = () => {
    //   const info = JSON.parse(BrowserMsgCenter.getLastCommentInfo());
    //   const resource = JSON.parse(info.resource);
    //   if (resource.article.contentType == 2) {
    //     // 视频详情页
    //     BrowserMsgCenter.jumpVideoDetailPage &&
    //       BrowserMsgCenter.jumpVideoDetailPage(
    //         JSON.stringify(resource.article),
    //       );
    //     return;
    //   }
    //   if (resource.article.contentType == 5) {
    //     // 小视频详情页
    //     BrowserMsgCenter.jumpSmallVideoDetailPage &&
    //       BrowserMsgCenter.jumpSmallVideoDetailPage(
    //         JSON.stringify(resource.article),
    //       );
    //     return;
    //   }
    //   if (resource.article.contentType == 0) {
    //     let url = resource.article.url;
    //     if (url.split('?').length > 1) {
    //       url = url + '&openSource=msg';
    //     } else {
    //       url = url + '?openSource=msg';
    //     }
    //     // 文章详情页
    //     BrowserMsgCenter.jump2ArticlePage &&
    //       BrowserMsgCenter.jump2ArticlePage(url);
    //     return;
    //   }
    // };

    const forbiddenReply = computed(() => {
      return commentStatus.value !== CommentStatus.DEFAULT;
    });

    const replyClass = computed(() => {
      return {
        'btn-button': true,
        'btn-reply': true,
        'disabled': forbiddenReply.value,
      };
    });

    // const title = documentMeta.value.title;

    // const isCommentSecondDetail = computed(() => {
    //   return pageType.value === 2 && isShowTitle.value && isBrowserVersionHigherThan('8.28');
    // });

    const addReply = () => {
      commonCommentStat(20084686);

      if (forbiddenReply.value) {
        showToast('系统维护中，评论暂不开放');

        return;
      }

      onCommentClickThrottle(itemData.value, {
        directComment: true,
      });
    };

    // const onReport = () => {
    //   commonCommentStat(20084701);

    //   onCommentClickThrottle(itemData.value, {
    //     directReport: true,
    //   });
    // };

    return {
      translateTimeStamp,

      userMeta,

      onDelete,
      addReply,

      isFromMsgCenter,
      // jumpToArticle,

      // title,
      // isCommentSecondDetail,
      // onReport,

      // feedbackIconName,
      // rightAreaIconName,
      replyClass,
    };
  },
});
</script>

<style lang="scss" scoped>
@import '../assets/css/styling-mixin.scss';

$barHeight: 110px;

.menu-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 36px;
  line-height: 48px;
}

.menu-bar-left {
  display: flex;
  // justify-content: space-between;
  align-items: center;
  overflow: hidden;
  white-space: nowrap;
  padding: 12px 0;
  flex: 1;
}

.menu-bar-sub {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex: 1;
}

.menu-bar-sub-content {
  display: flex;
  align-items: center;
  overflow: hidden;
}

.menu-bar-title {
  display: flex;
  color: rgba(0, 0, 0, 0.54);
  overflow: hidden;
  margin-left: 24px;
  &::after {
    width: 48px;
    height: 48px;
    background-image: url('../assets/img/right-area.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    content: '';
    flex-shrink: 0;
  }
}

.title {
  // margin: 0 34px 0 12px;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.right-area-icon {
  width: 48px;
  height: 48px;
}

.menu-bar-right {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 0.36rem;
  padding: 0.12rem;
  margin-right: -0.12rem;
  &:active {
    background-color: rgba(0, 0, 0, 0.06);
  }
  @include os-browser-styling('', '', false, false, true) {
    &:active {
      background-color: rgba(240, 240, 240, 1);
    }
  }
  @include os-browser-styling('', '', false, false, true, true) {
    &:active {
      background-color: rgba($color: #fff, $alpha: 0.15);
    }
  }
}

.time,
.place {
  font-size: 36px;
  line-height: 48px;
  font-weight: 400;
  letter-spacing: 0.02em;
  color: rgba($color: #000, $alpha: 0.26);
  @include os-browser-styling('', '', false, false, true) {
    color: rgba($color: #fff, $alpha: 0.3);
  }
}

.btn-reply {
  @include os-browser-styling('', '', false, false, true, true) {
    color: rgba($color: #fff, $alpha: 0.9);
  }
}

.btn-delete {
  @include os-browser-styling('', '', false, false, true, true) {
    color: rgba($color: #fff, $alpha: 0.26);
  }
}

html[data-theme='dark'] {
  .menu-bar-title {
    color: rgba($color: #fff, $alpha: 0.54);
    &::after {
      background-image: url('../assets/img/right-area-dark.png');
    }
  }
}

.btn-button {
  font-family: ColorFont-Regular, 'OPlusSans 3.0';
  font-weight: 400;
}

.btn-reply {
  color: rgba($color: #000, $alpha: 0.9);
  margin-right: 24px;
}

.btn-delete {
  color: rgba($color: #000, $alpha: 0.26);
}

.disabled {
  color: rgba(0, 0, 0, 0.15);
}

.btn-delete {
  margin-left: 30px;
}

.feedback-svg {
  width: 48px;
  height: 48px;
}
</style>
